var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromptLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0ZM19.708 41.2637L15.7324 45.2373C19.1926 47.7045 23.4275 49.1562 28.001 49.1562C32.5606 49.1562 36.783 47.7125 40.2373 45.2588L36.2422 41.2637H19.708ZM11.4453 32.3945L8.24902 35.5898C9.45527 38.7271 11.3866 41.5045 13.8389 43.7158H15.7471L23.4219 36.041H32.5254L40.2002 43.7158H42.1631C44.6042 41.5145 46.5281 38.7517 47.7354 35.6318L44.4932 32.3945H11.4453ZM28.001 6.84473C16.3173 6.84473 6.8459 16.3162 6.8457 28C6.84572 29.5067 7.00425 30.977 7.30371 32.3945H9.93359L21.2549 21.0732H34.6855L46.0137 32.3945H48.6982C48.9977 30.977 49.1562 29.5067 49.1562 28C49.1561 16.3164 39.6844 6.84497 28.001 6.84473ZM33.2168 12.21L38.4307 17.4189H17.4805L22.6895 12.21H33.2168Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptLogo);
export default __webpack_public_path__ + "static/media/prompt-logo.d019fae1238fd671c7961d2bfeeae721.svg";
export { ForwardRef as ReactComponent };